import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {CompetitorPlayersStatsModulePlayerViewModel} from "../models/competitor-players-stats-module.player.view-model";
import {EntityCarouselItem} from "../../../core/components/entity-carousel/entity-carousel.item";
import styles from "../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {RankingBadge} from "../../../core/components/ranking-badge/ranking-badge";

export class CompetitorPlayersStatsModuleHeaderTitlesProps extends BaseProps {
  player: CompetitorPlayersStatsModulePlayerViewModel;
}

export const CompetitorPlayersStatsModuleHeaderTitles = ({controller}: CompetitorPlayersStatsModuleHeaderTitlesProps) => {
  const {state, device} = controller;
  const {selectedPlayer, isSinglePlayer} = state
  const {isSmallView} = device;

  const rankingBadgeProps = {
    className: classNames(styles.header_badge_container),
    textClassName: classNames(styles.header_badge_text_container),
    text: selectedPlayer?.ranking,
    badgeClassName: selectedPlayer.badgeClassName
  }

  return (
    <div className={classNames(styles.header_titles_container)}>
      {
        isSinglePlayer ? <EntityCarouselItem entity={selectedPlayer} key={selectedPlayer.athleteId} isSmallView={isSmallView} isSinglePlayer={isSinglePlayer}/> : null
      }
      <div className={classNames(styles.header_title_container)}>
        <div className={classNames(styles.header_title_name_container)}>{selectedPlayer.name}</div>
        {
          selectedPlayer?.ranking ? <RankingBadge {...rankingBadgeProps}/> : null
        }
      </div>
      <div className={classNames(styles.header_subtitle_container)}>{selectedPlayer.formation?.name}</div>
    </div>
  )
}
